import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class DIWPriceControl extends TKCustomElementFactory {
    requestURL?: string;
    checkbox?: HTMLInputElement;

    constructor() {
        super();
        this.requestURL = this.getAttribute('data-tk-url') || undefined;
        this.checkbox = this.querySelector('#price-control') || undefined;
    }

    connectedCallback(): void {
        if (!this.requestURL) throw new Error('DIWPriceControl: Missung URL');
        if (!this.checkbox) throw new Error('DIWPriceControl: Missung Switch');

        const action = this.togglePriceVisibility.bind(this);
        this.pushListener({ event: 'change', element: this.checkbox, action });
    }

    togglePriceVisibility() {
        const payload = {
            'price-control': `${Number(this.checkbox!.checked)}`,
        };

        fetchRequest({
            requestURL: this.requestURL!,
            resolveHandler: this.handlePriceChange.bind(this),
            payload,
        });
    }

    handlePriceChange(response: TKResponse<{ success: string }>) {
        const success = response.dataAsJson.success;
        if (!success) throw new Error('DIWPriceControl: Sessionvar could not be set');

        window.location.reload();
    }
}
